































import { Component, Vue, Prop, Provide, Watch } from 'vue-property-decorator'
import draggable from 'vuedraggable'
import { updateQuestionCart } from './../model/api'
import { numToChinese } from './../model/numberToChinese'
import { isObjectValueEqual } from '@/utils/urlUtils'

@Component({ components: { draggable } })
export default class OrderList extends Vue {
  public data: any = []
  public get cartInfo() {
    return this.$store.state.question.cart
  }
  public get subjectId() {
    return this.$store.state.subject.value
  }
  @Watch('cartInfo', { deep: true })
  onCartChange(val, old) {
    if (isObjectValueEqual(val, old)) return
    this.getData()
  }
  @Watch('data', { deep: true })
  onDataChange(val, old) {
    // let temp: any = []
    // if (val && val.length) {
    //   console.log(val)
    //   for (let n of val) {
    //     for (let m of n.val) {
    //       temp = [...temp, m]
    //     }
    //   }
    // }
    // this.updateCart(temp)
  }
  public mounted() {
    this.getData()
  }
  public dragEnd() {
    // console.log(this.data)
    this.updateCart(this.data)
  }
  public async updateCart(data) {
    let params: any = {
      question_cart: {
        question_ids: this.cartInfo.question_ids,
        classification: data
      },
      subject_id: this.subjectId
    }
    // console.log(params)
    // params.question_cart.classification[data]
    let res = await updateQuestionCart(params)
    if (res.success) {
      this.$store.commit('SET_CART', res.msg)
    }
  }
  public getData() {
    this.data = JSON.parse(JSON.stringify(this.cartInfo.classification))
  }
  public handleNumber(idx, questons, index, classification) {
    let count = 0
    if (index === 0) {
      return idx + 1
    } else {
      for (let i = 0; i < index; i++) {
        count += classification[i].sequence.length
      }
      return count + idx + 1
    }
  }
  public handleCount(val) {
    return numToChinese(val)
  }
}
